(function ($) {

    var uid = (function () { var id = 1; return function () { if (arguments[0] === 0) id = 0; return id++; } })();

    var methods = {
        init: function (options) {
            //add binding to document to close when clicking outside of the control, (remove previous bindings to stop them from duplicating
            $('html').unbind('click.fancy-ddl');
            $('html').bind('click.fancy-ddl', function (e) {
                if (!$(e.target).hasClass('fancy-ddl-list') && !$(e.target).parents('.fancy-ddl-list').length) {
                    $('.fancy-ddl').removeClass('focus');
                    $('.fancy-ddl:not(.fancy-ddl-tooltip) .fancy-ddl-list').hide();
                }
            });

            // This is the easiest way to have default options.
            return this.each(function () {
                var settings = $.extend({
                    input: null,
                    inputParam: null,
                    display: null,
                    tooltipSelectedText: null
                }, options);

                var $list, $container, $selectedValue, thisUID;
                thisUID = uid();

                if ($(this).is('ul')) {
                    $list = $(this);
                    $list.addClass('fancy-ddl-list');

                    //show collapsed if there are any for the selected  item
                    $list.find('span.selected').siblings("ul.collapse").show();


                } else if ($(this).is('select')) {
                    //get select name to be able to set value later
                    settings.input = 'select[name="' + $(this).attr('name') + '"]';
                    settings.inputParam = 'val';

                    //create list from select
                    $list = $('<ul>').addClass('fancy-ddl-list');
                    $(this).find('option').each(function () {
                        var $item = $('<li>').append($('<span>').attr('data-val', $(this).attr('value')).text($(this).text()));
                        if ($(this).is(':selected')) $item.find('span').addClass('selected');
                        $list.append($item);
                    });

                    //hide select and place html list after it
                    $(this).hide();
                    $(this).after($list);

                    $(this).change(function () {
                        $list.fancyDDL('select', { k: 'val', v: $(this).val() });
                    });

                } else {
                    throw "invalid element";
                }


                $(settings.input).attr('data-fddl-id', thisUID);

                $list.wrap('<div class="fancy-ddl" id=""></div>');
                $container = $list.parent();

                $list.attr('data-fddl-id', thisUID);
                $list.attr('data-fddl-input', settings.input);
                $list.attr('data-fddl-param', settings.inputParam);
                $container.attr('data-fddl-id', thisUID);
                $container.attr('data-fddl-tttext', settings.tooltipSelectedText);

                $selectedValue = $('<span>').addClass('selected-value');
                //get initial value and populate
                if ($list.find('span.selected').length) {
                    $selectedValue.text($list.find('span.selected').text());
                }

                $container.prepend($selectedValue);

                if (options.appendListTo) {
                    $(options.appendListTo).append($list);
                }

                $list.perfectScrollbar();

                if (options.display == 'tooltip') {
                    $container.addClass('fancy-ddl-tooltip');
                    $selectedValue.remove();
                    $selectedValue = $(options.tooltipSelectedText);
                    $list.show();
                    $list.perfectScrollbar('update');
                }

                //when clicking the container toggle visibility
                $container.click(function (e) {
                    var self = this;
                    e.stopPropagation();
                    //remove focus from all other containers
                    $('.fancy-ddl').each(function () {
                        if ($(this).data('fddl-id') != $container.data('fddl-id')) {
                            $(this).removeClass('focus');
                        } else {
                            //found a match
                        }
                    });
                    $('.fancy-ddl-list').each(function () {
                        if ($(this) != $list && $(this).closest('.fancy-ddl-tooltip').length == 0) {
                            $(this).hide();
                        }
                    });

                    $container.toggleClass('focus');

                    //set list position relative to container
                    var fixedList = false;
                    var relativeFontSize = (window.innerWidth / screen.width) * 18;
                    if (!$container.hasClass('fancy-ddl-tooltip')) {
                        fixedList = screen.width <= 420;
                        $list.css({
                            'top': (fixedList ? '' : $container.position().top + $container.outerHeight()),
                            'left': (fixedList ? '' : $container.position().left),
                            'width': (fixedList ? '' : $container.width()),
                            'font-size': (fixedList ? relativeFontSize + 'px' : '')
                        });
                    }

                    $list.toggleClass('fixed', fixedList);


                    $list.toggle($container.hasClass('focus'));
                    //reset list scroll position back to top
                    $list.scrollTop(0);
                    var scrollTo = 0;
                    //if an element is selected
                    if ($container.find('span.selected').length) {
                        //find the selected items vertical position in the list
                        scrollTo = $container.find('span.selected').parent('li').position().top + $list.height() / 5;
                        //if its within view
                        if (scrollTo < $list.height()) {
                            scrollTo = 0;
                        }
                    }

                    $list.scrollTop(scrollTo);
                    $list.perfectScrollbar('update');
                });

                $list.find('span').click(function (e) {
                    e.stopPropagation();
                    var alreadySelected = $(this).hasClass('selected');

                    $list.find('span').removeClass('selected');
                    $(this).addClass('selected');

                    var $collapsedEls = $(this).siblings('ul.collapse');
                    if ($collapsedEls.length /*&& !$collapsedEls.is(':visible')*/) {
                        $collapsedEls.slideToggle(200, function () {
                            $list.perfectScrollbar('update');
                        });
                    } else {
                        //if expanded collapse lists are no longer applicable, hide them
                        if ($list.find('ul.collapse:visible').length) {
                            $list.find('ul.collapse:visible').each(function () {
                                if ($(this).find('span.selected').length === 0 && $(this).siblings('span.selected').length === 0) {
                                    $(this).hide();
                                }
                            });
                        }
                        if (!$container.hasClass('fancy-ddl-tooltip')) {
                            $container.removeClass('focus');
                            $list.hide();
                            $list.perfectScrollbar('update');
                        }
                    }

                    $selectedValue.text($(this).text());
                    if (!alreadySelected) {
                        $list.trigger('change');
                    }
                    if (settings.input !== null) {
                        $(settings.input).val($(this).data(settings.inputParam)).trigger('change');
                    }
                });
                $list.find('a').click(function (e) {
                    e.preventDefault();
                });

            });
        },
        value: function () {
            return $(this).find('span.selected').data('val');
        },
        text: function () {
            return $(this).find('span.selected').text();
        },
        getParam: function (param) {
            return $(this).find("span.selected").data(param);
        },
        getList: function () {
            var list = [];
            $(this).find("span[data-val]").each(function () {
                var item = {};
                $.each($(this).data(), function (k, v) {
                    item[k] = v;
                });
                list.push(item);
            });
            return list;
        },
        select: function (params) {
            //get span
            var $i = $(this).find("span[data-" + params.k + "='" + params.v + "']")
            var uid = $(this).data('fddl-id');
            if ($i.length) {
                var text = $i.text();
                var val = $i.data('val');
                var fddl = $(".fancy-ddl[data-fddl-id='" + uid + "']");
                fddl.find('.selected-value').text(text);
                if (fddl.attr('data-fddl-tttext')) {
                    $(fddl.attr('data-fddl-tttext')).text(text);
                }

                $(this).find("span").removeClass('selected');
                $i.addClass('selected');
                $(this).find('ul.collapse').hide();
                $i.parents('ul.collapse').slideDown();
                $i.siblings('ul.collapse').slideDown();
            }
        },
        updateList: function () {
            $(this).perfectScrollbar('update');
        }
    };



    $.fn.fancyDDL = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.fancyDDL');
        }
    };

} (jQuery));